define('customPlugins/atnUIValidation',['knockout', 'lodash', 'moment', 'atn/atn', 'knockout.validation'],
    function(ko, _, moment, atn) {
        'use strict';
        var kv = ko.validation,
            /**
             * associative mapping of type
             *     moduleId [string] => [{valid, error, global}] for each validatable element
             * @type {Object}
             */
            validationMap = {},
            //  CONSTANTS
            NODETYPE_INPUT = 'INPUT',
            INPUT_TYPES = ['url'],
            PROPERTIES = ['date', 'digit'],
            ATTRIBUTES = ['minLength', 'maxLength', 'equal', 'notEqual'],
            //  taken form http://code.tutsplus.com/tutorials/8-regular-expressions-you-should-know--net-6149
            URL_PATTERN = /^(https?:\/\/)?([a-zA-Z0-9\-]+)\.([a-zA-Z0-9.]+)\/?.*/,
            DOMAIN_PATTERN = /^(?!www\.)[a-zA-Z0-9]([a-zA-Z0-9\-]*\.)+[a-zA-Z]{2,9}$/,
            validationMessages = {
            //  These contants are required by Knockout, sokeeping them as it is
            required: 'This field is required.',
            allDatesAreRequired: 'Please provide the correct start and end dates.',
            min: 'Please enter a value greater than or equal to {0}.',
            max: 'Please enter a value less than or equal to {0}.',
            minLength: 'Please enter at least {0} characters.',
            maxLength: 'Maximum {0} characters allowed.',
            exactLength: 'Please provide exactly {0} characters.',
            pattern: 'Please provide value in correct format.',
            step: 'The value must increment by {0}',
            email: 'Please provide a valid Email address',
            date: 'Please enter a valid date',
            customDate: 'The date specified is either in an incorrect format or outside the permissible date range.',
            dateISO: 'Please enter a valid date',
            domainName: 'Please enter a valid domain name',
            domainNameLength: 'Domain name cannot contain more than 253 characters',
            domainNameNumber: 'Please enter no more than 15 Domain Names',
            number: 'Please enter a number',
            digit: 'Please enter a digit',
            phoneUS: 'Please specify a valid phone number',
            equal: 'Values must equal',
            notEqual: 'Please provide another value.',
            unique: 'Please make sure the value is unique.',
            url: 'Please enter a valid URL.',
            dateRange: 'Provide valid date range for start date and end date',
            durationDateRange: 'Provide valid From and To dates.',
            dateRangeReverse: 'start date must be less than end date.',
            futureDate:'Please select a future date/time value',
            startDate: 'Access logs for only the last 30 days are available for download.',
            commaSeperatedEmail: 'Invalid email address(es). Please enter valid, comma-separated email addresses.',
            memberOf: 'Please select a value from the list.',
            bothEndsTrimmed: 'Please remove the spaces at the start and/or the end.',
            //TODO: to be changed UPPERCASED
            like_page_blank: 'Like page URL cannot be blank',
            like_page_incorrect_format: 'Please provide a valid Like Page URL',
            follow_page_blank: 'Follow page URL cannot be blank',
            follow_page_incorrect_format: 'Please provide a valid Follow Page URL',
            guest_access_link_incorrect_format: 'Please provide a valid Guest Access URL (only http)',
            custom_menu_error_message: 'Input is not a valid JSON',
            webform_display_must_for_required: 'Please enable Display for below mentioned fields',
            guestbook_display_must_for_required: 'Please enable Display for below mentioned fields',
            sms_code_tag_required: 'Please mention &lt;code&gt; tag',
            username_incorrect_pattern: 'Username can contain only letters, numbers, dot(.), hyphen(-), underscore(_) and (@)',
            password_confirmation_failed: 'Password and Confirm Password do not match',
            pname_incorrect_format: 'Please provide a valid Portal Name',
            message_content_error_message: '<div>To create a text hyperlink, use {a} ----- {/a}. For ex: {a}Click Here{/a}</div>',
            httpUrl: 'Please enter a valid http(s) URL.',
            minMaxDifference: 'Difference between Minimum and Maximum must be atleast 200.',
            minValue: 'Minimum should be less than Maximum.',
            report_name: 'Report Name cannot contain any of the following characters: \\ / : * ? " < > |'
        };
        /**
         * [Custom Validator for URL
         * @type {Object}
         */
        kv.rules.url = {
            validator: function(val) {
                return kv.rules.pattern.validator(val, URL_PATTERN);
            },
            message: validationMessages.url
        };

        /**
         * dummyValidator to make sure validation is registerted
         * @type {Object}
         */
        kv.rules.__dummyValidator = {
            validator: function() {
                return true;
            }
        };

        /**
         * hasExactLength returns false when the length of the string is exactly as requested.
         */
        kv.rules.hasExactLength = {
            validator: function(val, len) {
                if (val) {
                    return val.length === len;
                } else {
                    return false;
                }
            },
            message: function(msgObj, observable) {
                if (observable()) {
                    return atn.utils.sformat(validationMessages.exactLength, msgObj);
                } else {
                    return validationMessages.required;
                }
            }
        };

        /**
         * hasBothEndsTrimmed returns invalid when there are leading or trailing spaces in the applied string.
         * @type {Object}
         */
        kv.rules.hasBothEndsTrimmed = {
            validator: function(val) {
                if (val) {
                    return val.match(/^\S.*\S$|^\S$/g);
                } else {
                    return false;
                }
            },
            message: function(msgObj, observable) {
                if (observable()) {
                    return validationMessages.bothEndsTrimmed;
                } else {
                    return validationMessages.required;
                }
            }
        };

        /**
         * isMemberOf returns valid(true) when 'options.isMember' is a member of 'options.memberOf'.
         * i.e. checks membership of an element within an array
         * @type {Object}
         */
        kv.rules.isMemberOf = {
            validator: function(msgObj, options) {
                var retVal,
                    isMember = ko.utils.unwrapObservable(options.isMember),
                    memberOf = ko.utils.unwrapObservable(options.memberOf);

                if (_.isFunction(memberOf)) {
                    memberOf = memberOf();
                }

                if (_.isFunction(isMember)) {
                    isMember = isMember();
                }

                if (!options.isValidationRequired()) {
                    //a flag to override validation and return true in al cases if it is not required to validate currently.
                    retVal = true;
                } else {
                    if (!isMember) {
                        //case when no value is passed to isMember option.I.e. element is  not-present/null/undefined/''.
                        retVal = false;
                    } else if (_.indexOf(memberOf, isMember) !== -1) {
                        //case when isMember(the element) is a memberOf the array.
                        retVal = true;
                    } else {
                        //if the element(isMember) is not found in the array(memberOf)
                        retVal = false;
                    }
                }
                return retVal;
            },
            message: function(msgObj, observable) {
                if (observable()) {
                    //if a value is passed to the observable and it was found to be invalid.
                    return validationMessages.memberOf;
                } else {
                    //case when no value is passed to isMember;return this required message then.
                    return validationMessages.required;
                }
            }
        };

        /**
         * isMemberOf returns valid(true) when 'options.isMember' is a member of 'options.memberOf'.
         * i.e. checks membership of an element within an array
         * @type {Object}
         */
        kv.rules.isMemberOfObjsArray = {
            validator: function(msgObj, options) {
                var retVal,
                    isMember = ko.utils.unwrapObservable(options.isMember),
                    memberOf = ko.utils.unwrapObservable(options.memberOf),
                    dataValueField = options.dataValueField;

                if (_.isFunction(memberOf)) {
                    memberOf = memberOf();
                }

                if (_.isFunction(isMember)) {
                    isMember = isMember();
                }

                if (!options.isValidationRequired()) {
                    //a flag to override validation and return true in al cases if it is not required to validate currently.
                    retVal = true;
                } else {
                    if (!isMember) {
                        //case when no value is passed to isMember option.I.e. element is  not-present/null/undefined/''.
                        retVal = false;
                    } else if (_.indexOf(memberOf, isMember) !== -1) {
                        //case when isMember(the element) is a memberOf the array.
                        retVal = true;
                    } else if (atn.utils.findInObjectArray(isMember, memberOf, dataValueField)) {
                        retVal = true;
                    } else {
                        //if the element(isMember) is not found in the array(memberOf)
                        retVal = false;
                    }
                }
                return retVal;
            },
            message: function(msgObj, observable) {
                var returnMsg;
                //no need to show the validation message
                if (msgObj.hideMessage()) {
                    returnMsg = '';
                } else if (observable()) {
                    //if a value is passed to the observable and it was found to be invalid.
                    returnMsg = validationMessages.memberOf;
                } else {
                    //case when no value is passed to isMember;return this required message then.
                    returnMsg = validationMessages.required;
                }
                return returnMsg;
            }
        };


        /**
         * emailCsvValidation returns invalid when any of the comma seperated email addresses is invalid or they are not comma seperated.
         * @type {Object}
         */
        kv.rules.emailCsvValidation = {
            validator: function(val, options) {
                var isValid = true;
                if (options.isValidationRequired && !options.isValidationRequired()) {
                    //a flag to override validation and return true in al cases if it is not required to validate currently.
                    isValid = true;
                } else {
                    //if no value is passed it is invalid.
                    if (!val) {
                        isValid = false;
                    }
                    if (!ko.validation.utils.isEmptyVal(val)) {
                        //split at comma and get a array of email addresses.
                        var values = val.split(',');
                        _.forEach(values, function(value) {
                            //trim spaces at the start/end.
                            value = value.replace(/^\s+|\s+$/gm, '');
                            isValid = isValid && kv.rules.email.validator(value, true);
                        });
                    }
                }
                return isValid;
            },
            message: function(msgObj, observable) {
                var returnValue = '',
                    obs = observable();
                if (obs) {
                    returnValue = validationMessages.commaSeperatedEmail;
                } else {
                    returnValue = validationMessages.required;
                }
                return returnValue;
            }
        };

        /**
         * dateValidation returns invalid when incorrect date is entered in kendoDatePicker or kendoDateTimePicker.
         * @type {Object}
         */
        kv.rules.dateValidation = {
            validator: function(msgObj, options) {
                var isValid = true;
                if (options.isValidationRequired()) {
                    isValid = true;
                } else if (!options.date()) {
                    isValid = false;
                } else {
                    isValid = true;
                }
                return isValid;
            },
            message: function(msgObj, observable) {
                return validationMessages.customDate;
            }
        };
        /**
         * dateRangeValidation returns invalid when end date is less than start date.
         * @type {Object}
         */
        kv.rules.dateRangeValidation = {
            validator: function(msgObj, options) {
                var returnVal;
                var startTime = moment(options.start());
                var endTime = moment(options.end());

                //if we do not require seconds precision then do the following..
                if (!options.secondsPrecision) {
                    if (startTime) {
                        startTime.seconds(0);
                    }
                    if (endTime) {
                        endTime.seconds(0);
                    }
                }
                if (options.validateOnlyIf()) {
                    returnVal = endTime.isAfter(startTime);
                } else {
                    returnVal = true;
                }
                return returnVal;
            },
            message: function(msgObj, observable) {
                var returnVal;
                if (observable()) {
                    returnVal = validationMessages.dateRange;
                } else {
                    returnVal = validationMessages.dateRange;
                }
                return returnVal;
            }
        };

        /**
         * dateRangeValidationIsSameOrAfter returns invalid when end date is not less or equal than start date.
         * @type {Object}
         */
        kv.rules.dateRangeValidationIsSameOrAfter = {
            validator: function(msgObj, options) {
                var returnVal;
                var startTime = moment(options.start());
                var endTime = moment(options.end());

                //if we do not require seconds precision then do the following..
                if (!options.secondsPrecision) {
                    if (startTime) {
                        startTime.seconds(0);
                    }
                    if (endTime) {
                        endTime.seconds(0);
                    }
                }
                if (options.validateOnlyIf()) {
                    returnVal = endTime.isAfter(startTime) || endTime.isSame(startTime);
                } else {
                    returnVal = true;
                }
                return returnVal;
            },
            message: function(msgObj, observable) {
                var returnVal;
                if (observable()) {
                    returnVal = validationMessages.durationDateRange;
                } else {
                    returnVal = validationMessages.durationDateRange;
                }
                return returnVal;
            }
        };

        /**
         * Required validation
         * @type {Object}
         */
        kv.rules.requiredConditional = {
            validator: function(msgObj, options) {
                var returnVal;
                var fieldValue = options.fieldValue();
                if (options.validateOnlyIf()) {
                    returnVal = (fieldValue == null) ? false : true;
                } else {
                    returnVal = true;
                }
                return returnVal;
            },
            message: function(msgObj, observable) {
                var returnVal;
                if (observable()) {
                    returnVal = validationMessages.required;
                }
                else {
                    returnVal = validationMessages.required;
                }
                return returnVal;
            }
        };

        /**
         * dateRangeValidation returns invalid when end date is less than start date.
         * @type {Object}
         */
        kv.rules.isPastDateValidation = {
            validator: function(msgObj, options) {
                var returnVal;
                var startTime = moment(options.date());
                var currentTime = moment();
                currentTime.add({minutes: currentTime.zone()});
                startTime.subtract({milliseconds: options.timezone()});
                //if we do not require seconds precision then do the following..
                if (!options.secondsPrecision) {
                    if (startTime) {
                        startTime.seconds(0);
                    }
                    if (currentTime) {
                        currentTime.seconds(0);
                    }
                }
                if (options.validateOnlyIf()) {
                    returnVal = startTime.isAfter(currentTime);
                } else {
                    returnVal = true;
                }
                return returnVal;
            },
            message: function(msgObj, observable) {
                var returnVal;
                if (observable()) {
                    returnVal = validationMessages.futureDate;
                } else {
                    returnVal = validationMessages.required;
                }
                return returnVal;
            }
        };

        /**
         * domainNameValidation returns invalid when any of the comma seperated domain names is not valid.
         * @type {Object}
         */
        kv.rules.domainNameValidation = {
            validator: function(msgObj, options) {
                var isValidValue = true,
                    list = options.list();
                if (options.onlyif()) {
                    if (list) {
                        var values = list.split(',');
                        // check if number of domain names is not greater than 15
                        if (values.length > 15) {
                            isValidValue = false;
                        }
                        isValidValue = _.reduce(values, function(isValid, value) {
                            // each domain name is valid and each domain name limit is 253 charatcters
                            var isValidPattern = kv.rules.pattern.validator(value, DOMAIN_PATTERN) && (value.length <= 253);
                            isValid = isValidPattern && isValid;
                            return isValid;
                        }, true);
                    } else {
                        isValidValue = false;
                    }
                }
                return isValidValue;
            },
            message: function(msgObj, observable) {
                var returnMsg,
                    values = observable() ? observable().split(',') : '',
                    isValidDomainLength = true;
                isValidDomainLength = _.reduce(values, function(isValid, value) {
                    var isValidLength = value.length <= 253;
                    isValid = isValidLength && isValid;
                    return isValid;
                }, true);

                // domain names should not be more than 15
                if (values.length > 15) {
                    returnMsg = validationMessages.domainNameNumber;
                    // Domain name length should not exceed 253 characters
                } else if (!isValidDomainLength) {
                    returnMsg = validationMessages.domainNameLength;
                    // if domain name does not match regular expression pattern
                } else if (!observable()) {
                    returnMsg = validationMessages.required;
                } else {
                    returnMsg = validationMessages.domainName;
                }
                return returnMsg;
            }
        };

        kv.registerExtenders();

        ko.bindingHandlers.atnValidationMessage = {
            init: function(element, valueAccessor) {
                var initialValue = ko.utils.unwrapObservable(valueAccessor());
                element.__initialValue = initialValue;
            },
            update: function(element, valueAccessor, allBindings, viewmodel, bindingContext) {
                var obsv = valueAccessor(),
                    newValue = ko.utils.unwrapObservable(obsv),
                    forceShow = bindingContext.$data.showAllMessages(),
                    isNotValid = _.isFunction(obsv.isValid) ? !obsv.isValid() : false;
                /**
                 * show the validation message only when showAllMessages(forceShow)
                 * is true and the elements value is changed or the field is invalid.
                 */
                if ((element.__initialValue !== newValue || isNotValid)) {
                    element.__initialValue = newValue;
                    ko.bindingHandlers.validationMessage.update.apply(element, arguments);
                }
            }
        };

        ko.bindingHandlers.atnUIValidation = {
            init: init,
            update: update
        };

        function init(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var accessorObject = extractSettings(valueAccessor, allBindings, element),
                viewmodel;
            /** [check if the current initialized element is a part of a sub-form or a grid i.e. a form composed inside a form
             * we create an additional property called parentModule for subforms and perform extra checks for subforms
             ] */
            if (accessorObject.parentModule || accessorObject.gridValidation) {
                // set the binding context of the parent form's context
                //!ToDo write a recursive function here
                bindingContext = bindingContext.$parentContext;
                if (!bindingContext.$data.showAllMessages) {
                    bindingContext = bindingContext.$parentContext;
                }
                //initialize an isDeleted property to the observable.
                if (!ko.isObservable(accessorObject.observable.isDeleted)) {
                    accessorObject.observable.isDeleted = ko.observable(false);
                }
                //initialize an isIgnored property to the observable.
                if (!ko.isObservable(accessorObject.observable.isIgnored)) {
                    accessorObject.observable.isIgnored = ko.observable(false);
                }
            }
            viewmodel = bindingContext.$data;
            //  in case viewmodel.showMessage() exists and has been turned on, turning it off
            if (ko.isObservable(viewmodel.showAllMessages)) {
                viewmodel.showAllMessages(false);
            }
            //  turning the isModified for the observable
            if (_.isFunction(accessorObject.observable.isModified)) {
                accessorObject.observable.isModified(false);
            }

            //  fetching the list of validation options passed
            var validationOptions = kv.utils.getConfigOptions(element);

            //  if the validation for that element has not been already added. add it
            if (!accessorObject.observable.isModified && !accessorObject.observable.isValid) {
                //adding validations
                addValidation(
                    accessorObject.validation,
                    accessorObject.observable,
                    viewmodel,
                    element,
                    accessorObject.settings,
                    accessorObject.parentModule
                );
                //for normal element we insert message only first time
                if (validationOptions.insertMessages && !accessorObject.settings.kendoElement) {
                    createValidationMessageElement(
                        element,
                        accessorObject.observable,
                        viewmodel
                    );
                }
                // in case of kendoElement, if name attribute is present, use it to
                // maintain additional attribute that provides hints to the DOM
                // regarding the validity of the property, it can be later
                // used by css to create additional look and feel, when those
                // properties are invalid
                (function() {
                    var propName = element.getAttribute('name')
                    if (accessorObject.settings.kendoElement && propName) {
                        ko.computed({
                            read: function() {
                                accessorObject.settings.kendoElement.setAttribute(
                                    'atn-valid-' + propName,
                                    accessorObject.observable.isValid() ? 'yes' : 'no'
                                );
                            },
                            disposeWhenNodeIsRemoved: element
                        });
                    }
                }());
            }
            //  for kendo element we always insert message
            if (validationOptions.insertMessages && accessorObject.settings.kendoElement) {
                createValidationMessageElement(
                    accessorObject.settings.kendoElement,
                    accessorObject.observable,
                    viewmodel
                );
            }
        }

        function update(element, valueAccessor, allBindings, viewmodel, bindingContext) {
            var accessorObject = extractSettings(valueAccessor, allBindings, element),
                domElement = (accessorObject.settings.kendoElement) ? accessorObject.settings.kendoElement : element;

            if (accessorObject.parentModule) {
                //!ToDo write the recursive function here.
                bindingContext = bindingContext.$parentContext;
                if (!bindingContext.$data.showAllMessages) {
                    bindingContext = bindingContext.$parentContext;
                }
            }

            ko.bindingHandlers.validationElement.update(domElement, validationElementAccessor, allBindings, viewmodel, bindingContext);

            function validationElementAccessor() {
                return accessorObject.observable;
            }
        }

        function createValidationMessageElement(element, observable, viewmodel) {
            // insert the <span></span>
            var validationMessageElement = kv.insertValidationMessage(element);
            //  applying binding to the node
            ko.applyBindingsToNode(validationMessageElement, {
                atnValidationMessage: observable
            }, viewmodel);
        }

        function addValidation(validation, observable, viewmodel, element, settings, parentModule) {
            var moduleId = parentModule ? parentModule : viewmodel.__moduleId__;
            //  add the given vatiodations with html validations
            addHTMLValidations(element, observable, validation);
            //  if there is no entry for a viewmodel
            if (!validationMap[moduleId]) {
                validationMap[moduleId] = ko.observableArray([]);
                attachProperties(moduleId, viewmodel);
            }

            //  adding subscription to showmessages
            viewmodel.showAllMessages.subscribe(function(show) {
                if (show) {
                    observable.isModified(true);
                }
            });

            //  adding observable ot the validation map
            validationMap[moduleId].push({
                observable: observable,
                isValid: observable.isValid,
                isDeleted: observable.isDeleted,
                isIgnored: observable.isIgnored,
                error: observable.error,
                global: !!settings.global
            });

        }

        function addHTMLValidations(element, observable, customValidation) {
            var validation = {};
            //  if element is a input and one of listed types the add corresponding validation
            if (element.nodeName === NODETYPE_INPUT) {
                _.each(INPUT_TYPES, function(type) {
                    if (element.type === type) {
                        validation[type] = true;
                    }
                });
            }
            //  if element has one of the selected property then add validator for that
            _.each(PROPERTIES, function(property) {
                if (element.hasAttribute(property)) {
                    validation[property] = true;
                }
            });
            //  if element has one of the selected attribute then add validator for that with the given value
            _.each(ATTRIBUTES, function(attribute) {
                if (element.hasAttribute(attribute)) {
                    validation[attribute] = element.getAttribute(attribute);
                }
            });

            _.extend(validation, customValidation);
            //  adding a dummy validator in case no validator is present.
            //  this is done so that validaors are at-least added
            if (_.isEmpty(validation)) {
                validation.__dummyValidator = true;
            }

            observable.extend(validation);
        }

        function attachProperties(moduleId, viewmodel) {
            var observableArray = validationMap[moduleId],
                //  computed property for globalValidationErrors
                globalErrors = ko.computed(computeGlobalErrors),
                //  computed property for isValid
                isValid = ko.computed(checkValidity),
                //  computed property for validationErrors
                errors = ko.computed(computeErrors);

            //  In case viewModel has provision to hold globalValidationErrors
            //  add globalValidationErrors to the viewmodel
            if (ko.isObservable(viewmodel.globalValidationErrors)) {
                globalErrors.subscribe(function(errorsArray) {
                    viewmodel.globalValidationErrors(errorsArray);
                });
            }
            //  In case viewModel has provision to hold validationErrors
            //  add validationErros to the viewmodel
            if (ko.isObservable(viewmodel.validationErrors)) {
                errors.subscribe(function(errorsArray) {
                    viewmodel.validationErrors(errorsArray);
                });
            }
            //  In case viewModel has provision to hold isValid
            //  add isValid to the viewmodel
            if (ko.isObservable(viewmodel.isValid)) {
                isValid.subscribe(function(isValid) {
                    viewmodel.isValid(isValid);
                });
            }

            /**
             * to cleanup all the validation errors in the viewmodel
             * @return {undefined}
             */
            viewmodel.cleanup = function() {
                cleanup(moduleId);
            };

            /**
             * function to compute if viewmodel has UI validation errors
             * @return {boolean} weather viewmodel has UI validation errors
             */
            function checkValidity() {
                //flag for the validation map removal task later in the function.
                var isObservableDeleted = false;
                var checkValid = _.reduce(observableArray(), function(isValid, object) {
                    var valid;
                    //check if the observable is still a  part of the viewmodel or is deleted;this is for composed subform elements.
                    if (object.observable.isDeleted && object.observable.isDeleted()) {
                        isObservableDeleted = true;
                        //by default make the deleted items to be valid.
                        valid = true;
                    } else if (object.observable.isIgnored && object.observable.isIgnored()) {
                        //by default make the deleted items to be valid.
                        valid = true;
                    } else {
                        valid = object.isValid();
                    }
                    return isValid && valid;
                }, true);

                //if this flag is set,then we have some elements removed from the viewmodel so we need to remove the validations as well.
                if (isObservableDeleted) {
                    _.remove(observableArray(), function(elem) {
                        return (!!elem.observable.isDeleted && elem.observable.isDeleted());
                    });
                }
                return checkValid;
            }

            /**
             * function to compute all the UI validation errors
             * @return {Array[string]} list of all UI validation errors
             */
            function computeErrors() {
                return _.compact(_.map(observableArray(), function(object) {
                    return object.error();
                }));
            }

            /**
             * function to compute all global the UI validation errors
             * @return {Array[string]} list of all global UI validation errors
             */
            function computeGlobalErrors() {
                return _.compact(_.map(observableArray(), function(object) {
                    var error;
                    if (object.global) {
                        error = object.error();
                    }
                    return error;
                }));
            }
        }

        function extractSettings(valueAccessor, allBindings, element) {
            var kendoFilter = ko.fiterKendoComponent(element, allBindings),
                attachedBindings = allBindings(),
                settings = ko.utils.unwrapObservable(valueAccessor()),
                //non validation keys are not relevant to atn validation.
                //These keys do not define a new validation rule but act as metadata for the validation library.
                NON_VALIDATION_KEYS = ['global', 'observable', 'validationParentModule', 'gridValidation'],
                //in case this is a kendo component then using it's value observable else using the passed or default observable
                observable =
                    (kendoFilter && kendoFilter.observable) ? kendoFilter.observable : settings.observable || attachedBindings.value || attachedBindings.checked || ko.observable(),
                validation,
                parentModule,
                gridValidation;

            if (settings.validation) {
                validation = settings.validation;
            } else {
                validation = {};
                _.forOwn(settings, function(value, key) {
                    if (_.indexOf(NON_VALIDATION_KEYS, key) === -1) {
                        validation[key] = value;
                    }
                });
            }
            //if there is a validationParentModule property it means that the element to be validated is a part of a composed subform.
            if (settings.validationParentModule) {
                parentModule = settings.validationParentModule;
            }

            if (settings.gridValidation) {
                gridValidation = true;
            }

            //  adding additional information in case it is kendo widget
            if (kendoFilter) {
                settings.kendoElement = kendoFilter.element;
            }

            return {
                settings: settings,
                observable: observable,
                validation: validation,
                parentModule: parentModule,
                gridValidation: gridValidation
            };

        }

        function cleanup(moduleId) {
            _.each(validationMap[moduleId](), function(object) {
                if (_.isFunction(object.observable.isModified)) {
                    object.observable.isModified(false);
                }
            });
        }

    });

